"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OevAuctionHouse__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_accessControlRegistry",
                type: "address",
            },
            {
                internalType: "string",
                name: "_adminRoleDescription",
                type: "string",
            },
            {
                internalType: "address",
                name: "_manager",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "AwardDetailsAreEmpty",
        type: "error",
    },
    {
        inputs: [],
        name: "AwardHasExpired",
        type: "error",
    },
    {
        inputs: [],
        name: "BidAmountIsZero",
        type: "error",
    },
    {
        inputs: [],
        name: "BidDetailsAreEmpty",
        type: "error",
    },
    {
        inputs: [],
        name: "BidFulfillmentCannotBeConfirmed",
        type: "error",
    },
    {
        inputs: [],
        name: "BidFulfillmentCannotBeContradicted",
        type: "error",
    },
    {
        inputs: [],
        name: "BidHasExpired",
        type: "error",
    },
    {
        inputs: [],
        name: "BidIsAlreadyPlaced",
        type: "error",
    },
    {
        inputs: [],
        name: "BidIsNotAwaitingAward",
        type: "error",
    },
    {
        inputs: [],
        name: "BidIsNotAwaitingFulfillmentReport",
        type: "error",
    },
    {
        inputs: [],
        name: "BidLifetimeIsLongerThanMaximum",
        type: "error",
    },
    {
        inputs: [],
        name: "BidLifetimeIsShorterThanMinimum",
        type: "error",
    },
    {
        inputs: [],
        name: "BidderAddressIsZero",
        type: "error",
    },
    {
        inputs: [],
        name: "BidderBalanceIsLowerThanTheLockedAmount",
        type: "error",
    },
    {
        inputs: [],
        name: "BidderCannotWithdrawYet",
        type: "error",
    },
    {
        inputs: [],
        name: "BidderHasAlreadyInitiatedWithdrawal",
        type: "error",
    },
    {
        inputs: [],
        name: "ChainIdIsZero",
        type: "error",
    },
    {
        inputs: [],
        name: "CollateralRateIsNotPositive",
        type: "error",
    },
    {
        inputs: [],
        name: "CollateralRateIsStale",
        type: "error",
    },
    {
        inputs: [],
        name: "DepositAmountIsZero",
        type: "error",
    },
    {
        inputs: [],
        name: "FulfillmentDetailsAreEmpty",
        type: "error",
    },
    {
        inputs: [],
        name: "InsufficientBalance",
        type: "error",
    },
    {
        inputs: [],
        name: "MaxCollateralAmountIsExceeded",
        type: "error",
    },
    {
        inputs: [],
        name: "MaxProtocolFeeAmountIsExceeded",
        type: "error",
    },
    {
        inputs: [],
        name: "MaximumAuctioneerDataLengthIsExceeded",
        type: "error",
    },
    {
        inputs: [],
        name: "MaximumBidderDataLengthIsExceeded",
        type: "error",
    },
    {
        inputs: [],
        name: "NativeCurrencyRateIsNotPositive",
        type: "error",
    },
    {
        inputs: [],
        name: "NativeCurrencyRateIsStale",
        type: "error",
    },
    {
        inputs: [],
        name: "ProxyAddressIsZero",
        type: "error",
    },
    {
        inputs: [],
        name: "RecipientAddressIsZero",
        type: "error",
    },
    {
        inputs: [],
        name: "SenderHasNotInitiatedWithdrawal",
        type: "error",
    },
    {
        inputs: [],
        name: "SenderIsNotAProxySetterOrTheManager",
        type: "error",
    },
    {
        inputs: [],
        name: "SenderIsNotAWithdrawerOrTheManager",
        type: "error",
    },
    {
        inputs: [],
        name: "SenderIsNotAnAuctioneer",
        type: "error",
    },
    {
        inputs: [],
        name: "SenderIsNotTheManager",
        type: "error",
    },
    {
        inputs: [],
        name: "TimestampDoesNotExpediteExpiration",
        type: "error",
    },
    {
        inputs: [],
        name: "WithdrawalAmountIsZero",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bidder",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bidId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "awardDetails",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bidderBalance",
                type: "uint256",
            },
        ],
        name: "AwardedBid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bidder",
                type: "address",
            },
        ],
        name: "CanceledWithdrawal",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bidder",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bidId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bidderBalance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "accumulatedProtocolFees",
                type: "uint256",
            },
        ],
        name: "ConfirmedFulfillment",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bidder",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bidId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bidderBalance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "accumulatedSlashedCollateral",
                type: "uint256",
            },
        ],
        name: "ContradictedFulfillment",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bidder",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bidderBalance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "Deposited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bidder",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bidId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "expirationTimestamp",
                type: "uint32",
            },
        ],
        name: "ExpeditedBidExpiration",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bidder",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "earliestWithdrawalTimestamp",
                type: "uint256",
            },
        ],
        name: "InitiatedWithdrawal",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bidder",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bidId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bidAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "bidDetails",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "expirationTimestamp",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "uint104",
                name: "collateralAmount",
                type: "uint104",
            },
            {
                indexed: false,
                internalType: "uint104",
                name: "protocolFeeAmount",
                type: "uint104",
            },
        ],
        name: "PlacedBid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bidder",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bidId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "fulfillmentDetails",
                type: "bytes",
            },
        ],
        name: "ReportedFulfillment",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "nativeCurrencyRateProxy",
                type: "address",
            },
        ],
        name: "SetChainNativeCurrencyRateProxy",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "collateralInBasisPoints",
                type: "uint256",
            },
        ],
        name: "SetCollateralInBasisPoints",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "collateralRateProxy",
                type: "address",
            },
        ],
        name: "SetCollateralRateProxy",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "protocolFeeInBasisPoints",
                type: "uint256",
            },
        ],
        name: "SetProtocolFeeInBasisPoints",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bidder",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Withdrew",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "WithdrewAccumulatedProtocolFees",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "WithdrewAccumulatedSlashedCollateral",
        type: "event",
    },
    {
        inputs: [],
        name: "AUCTIONEER_ROLE_DESCRIPTION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "FULFILLMENT_REPORTING_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAXIMUM_AUCTIONEER_DATA_LENGTH",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAXIMUM_BIDDER_DATA_LENGTH",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAXIMUM_BID_LIFETIME",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MINIMUM_BID_LIFETIME",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PROXY_SETTER_ROLE_DESCRIPTION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "WITHDRAWAL_WAITING_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "WITHDRAWER_ROLE_DESCRIPTION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "accessControlRegistry",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "accumulatedProtocolFees",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "accumulatedSlashedCollateral",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "adminRole",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "adminRoleDescription",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "auctioneerRole",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "bidder",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "bidDetailsHash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "awardDetails",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "awardExpirationTimestamp",
                type: "uint256",
            },
        ],
        name: "awardBid",
        outputs: [
            {
                internalType: "uint256",
                name: "bidderBalance",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "bidderToBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "bidderToEarliestWithdrawalTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "bids",
        outputs: [
            {
                internalType: "enum IOevAuctionHouse.BidStatus",
                name: "status",
                type: "uint8",
            },
            {
                internalType: "uint32",
                name: "expirationTimestamp",
                type: "uint32",
            },
            {
                internalType: "uint104",
                name: "collateralAmount",
                type: "uint104",
            },
            {
                internalType: "uint104",
                name: "protocolFeeAmount",
                type: "uint104",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "cancelWithdrawal",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "chainIdToNativeCurrencyRateProxy",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "collateralInBasisPoints",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "collateralRateProxy",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "bidder",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "bidDetailsHash",
                type: "bytes32",
            },
        ],
        name: "confirmFulfillment",
        outputs: [
            {
                internalType: "uint256",
                name: "bidderBalance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "accumulatedProtocolFees_",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "bidder",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "bidDetailsHash",
                type: "bytes32",
            },
        ],
        name: "contradictFulfillment",
        outputs: [
            {
                internalType: "uint256",
                name: "bidderBalance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "accumulatedSlashedCollateral_",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "deposit",
        outputs: [
            {
                internalType: "uint256",
                name: "bidderBalance",
                type: "uint256",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "bidder",
                type: "address",
            },
        ],
        name: "depositForBidder",
        outputs: [
            {
                internalType: "uint256",
                name: "bidderBalance",
                type: "uint256",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "bidDetailsHash",
                type: "bytes32",
            },
            {
                internalType: "uint32",
                name: "expirationTimestamp",
                type: "uint32",
            },
        ],
        name: "expediteBidExpiration",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "bidDetailsHash",
                type: "bytes32",
            },
        ],
        name: "expediteBidExpirationMaximally",
        outputs: [
            {
                internalType: "uint32",
                name: "expirationTimestamp",
                type: "uint32",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "bidAmount",
                type: "uint256",
            },
        ],
        name: "getCurrentCollateralAndProtocolFeeAmounts",
        outputs: [
            {
                internalType: "uint104",
                name: "collateralAmount",
                type: "uint104",
            },
            {
                internalType: "uint104",
                name: "protocolFeeAmount",
                type: "uint104",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "initiateWithdrawal",
        outputs: [
            {
                internalType: "uint256",
                name: "earliestWithdrawalTimestamp",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "manager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "multicall",
        outputs: [
            {
                internalType: "bytes[]",
                name: "returndata",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "bidAmount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "bidDetails",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "maxCollateralAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxProtocolFeeAmount",
                type: "uint256",
            },
        ],
        name: "placeBid",
        outputs: [
            {
                internalType: "uint32",
                name: "expirationTimestamp",
                type: "uint32",
            },
            {
                internalType: "uint104",
                name: "collateralAmount",
                type: "uint104",
            },
            {
                internalType: "uint104",
                name: "protocolFeeAmount",
                type: "uint104",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "bidAmount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "bidDetails",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "maxCollateralAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxProtocolFeeAmount",
                type: "uint256",
            },
            {
                internalType: "uint32",
                name: "expirationTimestamp",
                type: "uint32",
            },
        ],
        name: "placeBidWithExpiration",
        outputs: [
            {
                internalType: "uint104",
                name: "collateralAmount",
                type: "uint104",
            },
            {
                internalType: "uint104",
                name: "protocolFeeAmount",
                type: "uint104",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "protocolFeeInBasisPoints",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxySetterRole",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "bidDetailsHash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "fulfillmentDetails",
                type: "bytes",
            },
        ],
        name: "reportFulfillment",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "nativeCurrencyRateProxy",
                type: "address",
            },
        ],
        name: "setChainNativeCurrencyRateProxy",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "collateralInBasisPoints_",
                type: "uint256",
            },
        ],
        name: "setCollateralInBasisPoints",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "collateralRateProxy_",
                type: "address",
            },
        ],
        name: "setCollateralRateProxy",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "protocolFeeInBasisPoints_",
                type: "uint256",
            },
        ],
        name: "setProtocolFeeInBasisPoints",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "tryMulticall",
        outputs: [
            {
                internalType: "bool[]",
                name: "successes",
                type: "bool[]",
            },
            {
                internalType: "bytes[]",
                name: "returndata",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address payable",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address payable",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdrawAccumulatedProtocolFees",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address payable",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdrawAccumulatedSlashedCollateral",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "withdrawerRole",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class OevAuctionHouse__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(_accessControlRegistry, _adminRoleDescription, _manager, overrides) {
        return super.getDeployTransaction(_accessControlRegistry, _adminRoleDescription, _manager, overrides || {});
    }
    deploy(_accessControlRegistry, _adminRoleDescription, _manager, overrides) {
        return super.deploy(_accessControlRegistry, _adminRoleDescription, _manager, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.OevAuctionHouse__factory = OevAuctionHouse__factory;
//# sourceMappingURL=OevAuctionHouse__factory.js.map